import axios from "axios";
import localforage from "localforage";
import { API_BASE, LS_LAST_DATA_DATE } from "./Constants";
import utility from "./Utils";

const dataProvider = {};

// first layer
dataProvider.network = {};
dataProvider.local = {};

// local data layers
dataProvider.local.getItem = key => {
  return new Promise(async (resolve, reject) => {
    let data = null;
    try {
      data = await localforage.getItem(key);
    } catch (error) {
      console.error({ error });
    }

    resolve(data);
  });
};

dataProvider.local.setItem = (key, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await localforage.setItem(key, data);
      resolve(true);
    } catch (error) {
      console.error({ error });
      resolve(null);
    }
  });
};

// network layers
dataProvider.network.baseRequest = (url, method, body) => {
  return new Promise(async (resolve, reject) => {
    let token = await utility.getToken();
    if (!token) {
      console.error(`Failed to get token - data provider`);
      return;
    }
    console.log("jai ho new token", token);
    let opts = {
      method,
      url: `${API_BASE}/${url}`,
      headers: {
        Authorization: `Bearer ${token.token}`,
      },
    };

    if (method === "post") {
      opts.data = body;
    }

    axios(opts)
      .then(res => {
        resolve(res.data);
      })
      .catch(async error => {
        console.error("Error object:", error); // Log the entire error object
        if (error.response) {
          console.log("Error response status:", error.response.status); // Log the status code
          if (error.response.status === 401) {
           // console.log("jai ho- login jjk"); // Should print if status is 401
            console.error(`Token expired, redirecting to login`);

            //window.location = "/login";
        //    console.log("jai ho- login jjk");
            const refreshToken = await utility.getRefreshToken();
           // console.log(refreshToken);
            const newToken = await utility.refreshAccessToken();

            if (newToken !== "0") {
              // Retry the original request with the new token
              opts.headers.Authorization = `Bearer ${newToken}`;

              axios(opts).then(res => {
                resolve(res.data);
              });
            } else {
              console.log("Failed to refresh token, redirecting to login");
              window.location.href = "/login";
              // Redirect to login or handle accordingly
            }

            //await utility.removeTokens();
          } else {
            console.error({ error });
            reject(error);
          }
        } else {
          console.error("No response object found in error:", error);
        }
      });
  });
};

dataProvider.network.get = (url, dummy = false) => {
  return dataProvider.network.baseRequest(url, "get", null);
};

dataProvider.network.post = (url, data) => {
  return dataProvider.network.baseRequest(url, "post", data);
};

dataProvider.network.cacheGet = async url => {
  let cachedData;
  try {
    cachedData = await localforage.getItem(url);
  } catch (error) {
    cachedData = null;
  }

  if (!cachedData) {
    return dataProvider.network.baseRequest(url, "get", null);
  }

  return cachedData;
};

dataProvider.init = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let isNewData = false;

      let last_date = await dataProvider.local.getItem(LS_LAST_DATA_DATE);
      let res = await dataProvider.network.get("masters/last-upload");

      let ts = new Date(res.timestamp);
      let lts = new Date(last_date);

      console.info(`Last upload: ${ts}`);
      console.info({ ts, lts });

      if (!last_date || ts > lts) {
        isNewData = true;
      }

      if (isNewData) {
        // update timestamp in storage
        await dataProvider.local.setItem(LS_LAST_DATA_DATE, ts);

        // cache data again in storage
        // await cacheBrandMaster();
        // await cacheProgramMaster();
        // await cachePromoMaster();

        resolve(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      resolve(true);
    }
  });
};

const cacheProgramMaster = async () => {
  let data;
  try {
    data = await dataProvider.network.get("/masters/program");

    let transformedData = [];
    let lines = data.split("\n");
    for (let i = 0; i < lines.length; i++) {
      let cols = lines[i].split(",");
      transformedData.push(cols);
    }

    await localforage.setItem("/masters/program", transformedData);
    console.info("Program master cached");
  } catch (error) {
    console.error("failed to cache program master");
  }
};

const cacheBrandMaster = async () => {
  let data;
  try {
    data = await dataProvider.network.get("/masters/brandpromo/b");

    let transformedData = [];
    let lines = data.split("\n");
    for (let i = 0; i < lines.length; i++) {
      let cols = lines[i].split(",");
      transformedData.push(cols);
    }

    await localforage.setItem("/masters/brandpromo/b", transformedData);
    console.info("Brand master cached");
  } catch (error) {
    console.error("failed to cache brand master");
  }
};

const cachePromoMaster = async () => {
  let data;
  try {
    data = await dataProvider.network.get("/masters/brandpromo/p");

    let transformedData = [];
    let lines = data.split("\n");
    for (let i = 0; i < lines.length; i++) {
      let cols = lines[i].split(",");
      transformedData.push(cols);
    }

    await localforage.setItem("/masters/brandpromo/p", transformedData);
    console.info("Promo master cached");
  } catch (error) {
    console.error("failed to cache Promo master");
  }
};

export default dataProvider;
